import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Contact from './pages/Contact';
import BSC from './pages/BSC';
import FDL from './pages/FDL';
import Santander from './pages/Santander';
import ScrollToTop from "./util/scroll";
import './index.scss';
import './default.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/bsc-rwanda" element={<BSC />} />
            <Route path="/fdl" element={<FDL />} />
            <Route path="/santander" element={<Santander />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </ScrollToTop>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);